/**
 * Partner Program entity class
 */

import moment from 'moment'

/**
 * PartnerProgramFactory
 * returns Partner Program entity class
 *
 * @class PartnerProgramFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.PartnerProgram} class
 *
 * @ngdoc factory
 * @name mwApp.factory:PartnerProgramFactory
 */
/* @ngInject */
export default function PartnerProgramFactory ($http, alertLiteSvc, Entity, FileUploadMixin) {
  /* === PartnerProgram class === */

  /**
   * PartnerProgram model
   *
   * @class PartnerProgram
   * @classdesc PartnerProgram model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.upDownMixin
   * @return {models.PartnerProgram} PartnerProgram entity
   */
  function PartnerProgram () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  PartnerProgram.prototype = Object.create(Entity.prototype)
  PartnerProgram.prototype.constructor = PartnerProgram

  /* === PartnerProgram instance methods & fields === */

  Object.assign(PartnerProgram.prototype, {

    /**
     * instance fields
     *
     * @memberof models.PartnerProgram#
     * @type {Object}
     */
    _fields: {
      id: Number,
      apiKey: String,
      coverImageUrl: String,
      verticalImageUrl: String,
      description: String,
      name: String,
      partnerCode: String,
      partnerProductCount: Number,
      partnerProviderUrl: String,
      partnerProvider: 'iQIYI',
      partnersProgramType: 'REDIRECT',
      staticRedeemUrl: String,
      updatedBy: String,
      updatedTime: String,
      // for HBO only
      brandId: String,
      jwtKeys: {
        publicKey: String,
        privateKey: String
      },
      secretKey: String,
      signatureKeys: {
        publicKey: String,
        privateKey: String
      },
      deeplinkTemplate: String,
      weblinkTemplate: String,
      $sortDate: String
    },

    /**
     * url template
     *
     * @memberof models.PartnerProgram#
     * @type {String}
     */
    _urlTemplate: 'api/partners-program/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.PartnerProgram#
     * @type {String}
     */
    _publicUrlTemplate: 'partner-programs/{{::id}}',

    /**
     * Prepare PartnerProgram
     *
     * @memberof models.PartnerProgram#
     * @override
     */
    _prepare: function () {
      this.$sortDate = moment(this.updatedTime).format('YYYY/MM/DDTHH:mm')
    }
  }, FileUploadMixin)

  /* === PartnerProgram static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(PartnerProgram, Entity)
  PartnerProgram._name = 'PartnerProgram'
  PartnerProgram.init()

  // permissions
  PartnerProgram.access = {
  }

  // extra
  PartnerProgram.extra = {
    allowedPartnerProviderTypes: [String]
  }
  return PartnerProgram
}
